export default __webpack_public_path__ + "static/media/AirBnB.de10c4c2.png";